export function scrollhintFunc() {
  // SPのみ
  const mql = window.matchMedia('(max-width: 768px)');
  if (!mql.matches) return;

  if (!document.querySelector('.js-scrollable')) return;

  // CDN 読み込み確認
  if (typeof window.ScrollHint !== 'function') {
    console.warn('[ScrollHint] CDNが読み込まれていません。先に <script src="...scroll-hint.min.js"> を読み込んでください。');
    return;
  }

  // 二重初期化ガード
  if (window.__scrollHintInited) return;

  new ScrollHint('.js-scrollable', {
    suggestiveShadow: true,
    scrollHintIconAppendClass: 'scroll-hint-icon-white',
    i18n: { scrollable: '横にスクロールできます' }
  });

  window.__scrollHintInited = true;

  if (mql.addEventListener) {
    mql.addEventListener('change', (e) => {
      if (e.matches) {
        window.__scrollHintInited = false;
        scrollhintFunc();
      }
    });
  }
}


